import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import {
  Copy,
  Check,
  Key
} from "lucide-react";

interface TokenResponse {
  token: string;
  generatedAt: string;
  expiresAt?: string;
  generatedFor?: {
    id: string;
    displayName: string;
    codicePersona: string;
  };
}

interface TokenDisplayModalProps {
  token: TokenResponse;
  isOpen: boolean;
  onClose: () => void;
}

export function TokenDisplayModal({ token, isOpen, onClose }: TokenDisplayModalProps) {
  const [copied, setCopied] = useState(false);

  const handleCopyToken = async () => {
    try {
      await navigator.clipboard.writeText(token.token);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (error) {
      console.error("Error copying token:", error);
    }
  };

  const handleClose = () => {
    setCopied(false);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Key className="h-5 w-5" />
            Welfare Token Generated
          </DialogTitle>
        </DialogHeader>

        <div className="space-y-4">
          <div className="text-center">
            <div className="font-mono text-sm bg-muted p-3 rounded-lg break-all mb-3">
              {token.token}
            </div>
            <Button
              onClick={handleCopyToken}
              className="w-full"
              variant={copied ? "default" : "outline"}
            >
              {copied ? (
                <>
                  <Check className="h-4 w-4 mr-2 text-green-600" />
                  Copied to Clipboard!
                </>
              ) : (
                <>
                  <Copy className="h-4 w-4 mr-2" />
                  Copy Token
                </>
              )}
            </Button>
          </div>
        </div>

        <div className="flex gap-2 pt-4">
          <Button variant="outline" onClick={handleClose} className="flex-1">
            Close
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}